import { CommonModule } from '@angular/common';
import {
  Component, ChangeDetectionStrategy, Input, ViewChild, ElementRef, AfterViewInit,
  Output, EventEmitter, OnChanges, SimpleChanges, ViewEncapsulation
} from '@angular/core';
import * as noUiSlider from 'nouislider';

import { isEmpty, isNullOrUndefined } from '@app/util/util';
import { SliderRanges } from '@design-system/components/atoms/slider/entities/slider.types';

@Component({
  selector: 'app-ds-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule]
})
export class SliderDsComponent implements AfterViewInit, OnChanges {

  @Input() ranges: SliderRanges = [];
  @Input() picked: SliderRanges = [];

  @Output() setSlider: EventEmitter<string[]> = new EventEmitter<string[]>();
  @Output() updateSlider: EventEmitter<string[]> = new EventEmitter<string[]>();
  @Output() changeSlider: EventEmitter<string[]> = new EventEmitter<string[]>();
  @Output() slideSlider: EventEmitter<string[]> = new EventEmitter<string[]>();

  @ViewChild('sliderDsRange', { static: true }) public sliderDsRange: ElementRef;

  private uiSlider: noUiSlider;

  public minValue = 0;
  public maxValue = 0;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.picked && !isNullOrUndefined(this.uiSlider) && this.sliderDsRange?.nativeElement) {
      this.setUiSlider();
    }
  }

  ngAfterViewInit(): void {
    this.initUiSlider();
  }

  get min(): number {
    return this.ranges?.[0] ?? 0;
  }

  get max(): number {
    return this.ranges?.[1] ?? 0;
  }

  private get equalRanges(): boolean {
    return this.min === this.max;
  }

  private initUiSlider(): void {
    if (this.sliderDsRange?.nativeElement && !this.equalRanges) {
      this.uiSlider = noUiSlider.create(
        this.sliderDsRange.nativeElement,
        {
          cssPrefix: 'sliderDs--',
          start: [this.min, this.max],
          connect: true,
          range: {
            'min': this.min,
            'max': this.max
          }
        }
      );
      this.setUiSlider();
      this.uiSliderEvents();
      this.resetUiSlider();
    }
  }

  private setUiSlider(): void {
    this.minValue = !isNullOrUndefined(this.picked?.[0]) ? this.picked[0] : this.min;
    this.maxValue = !isNullOrUndefined(this.picked?.[1]) ? this.picked[1] : this.max;
    this.uiSlider.set([this.minValue, this.maxValue]);
  }

  private uiSliderEvents(): void {
    this.uiSlider.on('set', (values: string[]) => this.setSlider.emit(values));
    this.uiSlider.on('update', (values: string[]) => this.updateSlider.emit(values));
    this.uiSlider.on('change', (values: string[]) => this.changeSlider.emit(values));
    this.uiSlider.on('slide', (values: string[]) => this.slideSlider.emit(values));
  }

  private resetUiSlider(): void {
    if (isEmpty(this.picked)) {
      this.uiSlider.reset();
    }
  }

}

